var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",attrs:{"required":_vm.required},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.filteredStatuses),function(status,index){return _c('option',{key:index,domProps:{"value":status}},[_vm._v(_vm._s(status))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }